import React from "react";
import { useNavigate } from "react-router-dom";
import strings from "translate/language";
import { getWebEnvironmentBanner } from "utils/constants";
import "./Login/Login.css";

/**
 * Shared split-panel shell matching the login screen.
 */
const AuthShell = ({
  title,
  subtitle,
  children,
  showLegal = true,
  showBackToLogin = true,
  onBackToLogin,
  visualEyebrow = "JUSTO",
  visualTitle = strings.loginHeroHeadline,
  visualSupport = strings.loginHeroSupport,
}) => {
  const navigate = useNavigate();
  const envBanner = getWebEnvironmentBanner();

  const handleBackToLogin = () => {
    if (typeof onBackToLogin === "function") {
      onBackToLogin();
      return;
    }
    navigate("/");
  };

  return (
    <div className="page-wrapper justo-login-page">
      <div className="container-fluid p-0">
        <div className="authentication-main justo-login">
          <div className="justo-login__backdrop" aria-hidden="true">
            <div className="justo-login__backdrop-grid" />
          </div>

          <div className="justo-login__content">
            <div className="justo-login__panel">
              <aside className="justo-login__visual" aria-hidden="false">
                <div className="justo-login__visual-media">
                  <img
                    src="/assets/images/property.jpg"
                    alt=""
                    className="justo-login__visual-img"
                  />
                  <div className="justo-login__visual-shade" />
                </div>
                <div className="justo-login__visual-copy">
                  <p className="justo-login__visual-eyebrow">{visualEyebrow}</p>
                  <h2 className="justo-login__visual-title">{visualTitle}</h2>
                  <p className="justo-login__visual-support">{visualSupport}</p>
                </div>
              </aside>

              <section className="justo-login__form-pane">
                <div className="justo-login__form-inner">
                  <div className="justo-login__brand-wrap">
                    <img
                      className="justo-login__brand"
                      src="/assets/images/JUSTOLOGO.jpg"
                      alt="Justo"
                    />
                    <p className="justo-login__tagline">
                      {strings.companyTagline}
                    </p>
                    {envBanner ? (
                      <p className="justo-login__env-banner" role="status">
                        {envBanner}
                      </p>
                    ) : null}
                  </div>

                  <div className="justo-login__intro">
                    <h1 className="justo-login__title">{title}</h1>
                    {subtitle ? (
                      <p className="justo-login__subtitle">{subtitle}</p>
                    ) : null}
                  </div>

                  {children}

                  {showBackToLogin ? (
                    <div className="justo-login__back">
                      <button
                        type="button"
                        className="justo-login__forgot"
                        onClick={handleBackToLogin}
                      >
                        {strings.backToLogin}
                      </button>
                    </div>
                  ) : null}

                  {showLegal ? (
                    <div className="justo-login__legal">
                      <button
                        type="button"
                        className="justo-login__legal-link"
                        onClick={() => navigate("/termandcondition")}
                      >
                        {strings.loginTermsLink}
                      </button>
                      <span
                        className="justo-login__legal-dot"
                        aria-hidden="true"
                      >
                        ·
                      </span>
                      <button
                        type="button"
                        className="justo-login__legal-link"
                        onClick={() => navigate("/privacypolicy")}
                      >
                        {strings.loginPrivacyLink}
                      </button>
                    </div>
                  ) : null}
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthShell;
